<div class="deletion-progress-dialog">
  <h2 mat-dialog-title>
    <mat-icon *ngIf="!isComplete" class="progress-icon">delete</mat-icon>
    <mat-icon *ngIf="isComplete && failureCount === 0" class="success-icon">check_circle</mat-icon>
    <mat-icon *ngIf="isComplete && failureCount > 0" class="warning-icon">warning</mat-icon>
    <span *ngIf="!isComplete">Deleting Activities...</span>
    <span *ngIf="isComplete && failureCount === 0">Deletion Complete</span>
    <span *ngIf="isComplete && failureCount > 0">Deletion Complete with Errors</span>
  </h2>

  <mat-dialog-content>
    <div class="progress-container">
      <!-- Progress Bar -->
      <mat-progress-bar
        mode="determinate"
        [value]="progressValue"
        [class.complete]="isComplete"
        [class.has-errors]="failureCount > 0">
      </mat-progress-bar>

      <!-- Progress Text -->
      <div class="progress-text">
        <span class="count">{{ completedCount }} of {{ totalCount }}</span>
        <span class="percentage">{{ progressValue | number:'1.0-0' }}%</span>
      </div>

      <!-- Current Activity (only show during progress) -->
      <div *ngIf="!isComplete && currentActivity" class="current-activity">
        <span class="label">Deleting:</span>
        <span class="activity">{{ currentActivity }}</span>
      </div>

      <!-- Completion Summary -->
      <div *ngIf="isComplete" class="completion-summary">
        <div class="summary-row success" *ngIf="successCount > 0">
          <mat-icon>check_circle</mat-icon>
          <span>{{ successCount }} {{ successCount === 1 ? 'activity' : 'activities' }} deleted successfully</span>
        </div>
        <div class="summary-row error" *ngIf="failureCount > 0">
          <mat-icon>error</mat-icon>
          <span>{{ failureCount }} {{ failureCount === 1 ? 'activity' : 'activities' }} failed to delete</span>
        </div>
        <p class="reload-message">
          Click <strong>Close</strong> to reload the page and see the updated worklog.
        </p>
      </div>

      <!-- Cancelled Message -->
      <div *ngIf="isCancelled && !isComplete" class="cancelled-message">
        <mat-icon>info</mat-icon>
        <span>Deletion cancelled. Remaining activities were not deleted.</span>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button
      *ngIf="!isComplete && !isCancelled"
      mat-button
      (click)="onCancel()"
      class="cancel-button">
      Cancel Remaining
    </button>
    <button
      *ngIf="isComplete || isCancelled"
      mat-raised-button
      (click)="onClose()"
      class="close-button">
      Close
    </button>
  </mat-dialog-actions>
</div>
